import axios from 'axios'
import store from '../../store/index'

const state = {
  user: {},
}

const mutations = {
  user_data (state, company) {
    state.user = company
  },
}

const actions = {
  userUpdate ({ commit }, user) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/user',
        data: user,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('user_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  passwordUpdate ({ commit }, resetPass) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/user/resetPass',
        data: resetPass,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('user_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  userRequest ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/user',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          commit('user_data', resp.data.message)
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  checkIsActive ({ commit }) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/User/isActive',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
